import { initialState } from "./reducer";
import { useContext, createContext } from "react";

export const StateContext = createContext([initialState, () => null]);

export function useStateContext() {
  return useContext(StateContext);
}
